import { SupportedLanguage } from '@/models/TranslatableField';
import { useTranslation } from 'react-i18next';

import { LanguageSelector } from './LanguageSelector';

type FeedbackFormTitleProps = {
  activeLanguage: SupportedLanguage;
  onLanguageChange: (lang: SupportedLanguage) => void;
};
export function FeedbackFormTitle({
  activeLanguage,
  onLanguageChange,
}: FeedbackFormTitleProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.questionsTab.createQuestionModal.feedbacks',
  });

  return (
    <div className="flex justify-between items-center">
      <h3 className="text-base font-semibold text-base-content">
        {t('title')}
      </h3>
      <LanguageSelector
        activeLanguage={activeLanguage}
        onLanguageChange={onLanguageChange}
      />
    </div>
  );
}
